import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export function Faq({ items, testid }) {
  return (
    <Accordion type="single" collapsible className="divide-y divide-[#C9A961]/30 border-y border-[#C9A961]/30" data-testid={testid}>
      {items.map((f, i) => (
        <AccordionItem key={f.q} value={`f-${i}`} className="border-0">
          <AccordionTrigger data-testid={`${testid}-q-${i}`} className="font-editorial text-xl md:text-2xl text-[#1D3A2F] text-left py-6 hover:no-underline hover:text-[#A68840]">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-[#222]/70 leading-relaxed pb-6 max-w-3xl">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
